export const isLinkRecoveryMethod = (sessionData) => {
  const lastIndex = sessionData?.authentication_methods.length - 1;
  return sessionData?.authentication_methods[lastIndex]?.method === "link_recovery";
};
export const getInitials = (name = "User") => {
  const words = name.split(" ");
  let initials;
  if (words.length > 1) {
    initials = (words[0]?.charAt(0) ?? "") + (words[words.length - 1]?.charAt(0) ?? "");
  } else {
    initials = name.substring(0, 2);
  }
  return initials.toUpperCase();
};
